import { supabase } from './supabase';

export interface BrandTheme {
  slug: string;
  name: string;
  logoUrl: string | null;
  primaryColor: string;
  accentColor: string;
  creditsBalance?: number;
  userRole?: string;
}

export async function resolveBrandFromDomain(): Promise<BrandTheme | null> {
  if (!supabase) return null;

  const hostname = window.location.hostname;
  const devSlug = new URLSearchParams(window.location.search).get('brand');

  if (devSlug || hostname === 'localhost') {
    const slug = devSlug || 'default';
    const { data } = await supabase
      .from('public_brand_info')
      .select('*')
      .eq('slug', slug)
      .single();
    if (!data) return null;
    return {
      slug: data.slug,
      name: data.name,
      logoUrl: data.logo_url,
      primaryColor: data.primary_color,
      accentColor: data.accent_color
    };
  }

  const { data } = await supabase.rpc('resolve_brand_by_domain', { p_domain: hostname });
  if (!data || data.length === 0) return null;
  return {
    slug: data[0].brand_slug,
    name: data[0].brand_name,
    logoUrl: data[0].logo_url,
    primaryColor: data[0].primary_color,
    accentColor: data[0].accent_color
  };
}

export async function loadUserBrand(): Promise<BrandTheme | null> {
  if (!supabase) return null;

  const { data } = await supabase.rpc('get_user_brand');
  if (!data || data.length === 0) return null;
  const b = data[0];
  return {
    slug: b.brand_slug,
    name: b.brand_name,
    logoUrl: b.logo_url,
    primaryColor: b.primary_color,
    accentColor: b.accent_color,
    creditsBalance: b.credits_balance,
    userRole: b.user_role
  };
}
